import { useToken } from "@/hooks/useToken";
import { useAuthStore } from "@/stores/auth";
import type { NavigationGuardNext, RouteLocationNormalized } from "vue-router";

export const authGuard = async (
    to: RouteLocationNormalized,
    _from: RouteLocationNormalized,
    next: NavigationGuardNext
) => {
    const { getToken } = useToken();
    const token = getToken();
    const authStore = useAuthStore();
    const requiresAuth = to.matched.some(record => record.meta.authRequired);
    const requiresSuperAdmin = to.matched.some(record => record.meta.superAdminRequired);

    if (requiresAuth) {
        if (!token) {
            // Redirect to login with return URL
            next({
                path: '/login',
                query: { redirect: to.fullPath }
            });
        } else {
            // 检查管理员权限
            if (!authStore.isAdmin) {
                // 权限不足，重定向到登录页面并显示错误信息
                next({
                    path: '/login',
                    query: {
                        redirect: to.fullPath,
                        error: 'insufficient_permissions'
                    }
                });
            } else {
                if (requiresSuperAdmin && !authStore.isSuperAdmin) {
                    next({
                        path: '/login',
                        query: {
                            redirect: to.fullPath,
                            error: 'insufficient_permissions'
                        }
                    });
                } else {
                    next();
                }
            }
        }
    } else {
        next();
    }
};
